import { matchPath } from 'react-router'
import { RACES_ROUTES } from '@core/AppRoutes'

export const isRaceRoute = (path: string): boolean =>
  RACES_ROUTES.some(route =>
    Array.isArray(route)
      ? route.some(route => isRouteMatch(route, path))
      : isRouteMatch(route as string, path)
  )

function isRouteMatch(route: string, path: string) {
  if (matchPath(route, path)) {
    return true
  }
  if (!route.endsWith('/')) {
    // new v7 router check for non exact paths like this
    return matchPath(route + '/*', path)
  }
  return false
}
